var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-right",staticStyle:{"padding-top":"0.34rem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }